/* eslint-disable @typescript-eslint/no-explicit-any */
import dayjs from 'dayjs'

const FILE_NAME_DATE_FORMAT = 'll'
const FILE_FORMAT_ORIGIN = 'YYYYMMDD'

const formatFilename = (ticketId: number, file: string, type: string, extension: string) => {
  const date = file.split('-')

  return `tripID-${ticketId}-${type}-${dayjs(date[0], FILE_FORMAT_ORIGIN)
    .utc()
    .local()
    .format(FILE_NAME_DATE_FORMAT)}.${extension}`
}

const trimText = (text: string, large: number) =>
  text.length > large ? `${text.slice(0, large)}...` : text

const classesToString = (classes: (string | number | undefined | null | boolean)[]) =>
  classes.filter(item => !!item).join(' ')

export const StringUtils = {
  formatFilename,
  trimText,
  classesToString,
}
